var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['residence-map-wrapper', _vm.visible ? 'map-visible' : '']},[_c('div',{ref:"residenceMap",staticClass:"map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }